export default "__VITE_ASSET__cce727e4__"